import styled from '@emotion/styled'

export const SectionContainer = styled.div<{ className?: string }>`
  @media (min-width: 768px) {
    border-width: 1px;
    padding: 1.5rem;
    border-color: #e7e6e4;
  }
  border-radius: 1rem;
  height: 100%;
`
